import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { ATMContainer } from 'shared-it-appmod-ui';
import RiskAssessmentComponent from './risk-assessment/risk-assessment.component';
import styles from './flight-assessment.module.scss';

export type IProps = RouteComponentProps<{
  id: string;
}>;

const FlightAssessment: React.FC<IProps> = ({ match }) => {
  const requestId = Number(match.params.id);

  return (
    <ATMContainer className={styles.wrapper}>
      <RiskAssessmentComponent requestId={requestId} />
    </ATMContainer>
  );
};

export default FlightAssessment;
